// extracted by mini-css-extract-plugin
export default {"container":"NotificationModal_container__lurvX","title":"NotificationModal_title__-t2rb","btn":"NotificationModal_btn__s2X+6"};